import { render, staticRenderFns } from "./UserNotificationSettings.vue?vue&type=template&id=7b70ba01&"
import script from "./UserNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./UserNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VDivider,VIcon,VSelect,VTextField})
